import { Alert } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import * as H from 'history'
import  React from 'react'
import { ProfileController } from '../controllers/ProfileController'
import { ProfileModel } from '../models/ProfileModel'
import { ProfilePayload } from '../models/ProfilePayload'
import { ISupportSpinner } from '../shared/Ajax'
import { Option } from '../shared/fields/Options'
import { Backdrop } from '../shared/Backdrop'
import {
  AbnField, EmailField, PhoneField, TextField, TextRadioButtonField, validateFields, AddressField,
} from '../shared/fields'
import { SalutationField } from '../shared/fields/SalutationField'
import { TimeoutPopup } from '../shared/TimeoutPopup'

export interface RequestPageProps {
    history: H.History
}

export interface RequestPageState extends ProfilePayload {
    loading: boolean
    currentAccountType: string
}

export const accountTypeDataSource = [{ value: 'Individual', label: 'Individual' }, { value: 'Consultant', label: 'Consultant' }, { value: 'QIPConsultant', label: 'QIP Consultant' }]

export class RequestPage extends React.Component<RequestPageProps, RequestPageState> implements ISupportSpinner {
    ajax: ProfileController
    acountType: TextRadioButtonField
    title: SalutationField
    firstName: TextField
    lastName: TextField
    address: AddressField
    phone: PhoneField
    mobile: PhoneField
    email: EmailField

    constructor(props: RequestPageProps) {
      super(props)

      this.ajax = new ProfileController()

      this.state = {
        loading: false,
        model: {
          abn: '',
          accountType: '',
          email: '',
          firstName: '',
          lastName: '',
          mobile: '',
          phone: '',
          registredName: '',
          title: '',
          address: null,
        },
        requestedAccountType: null,
        currentAccountType: null,
        addressCountries: [],
      }
    }

    componentDidMount() {
      this.ajax.get(this, (p) => {
        this.setState({ ...p, currentAccountType: p.model.accountType })
      })
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    onSave = () => {
      validateFields((res) => {
        if (res) {
          this.ajax.submitRequest(this, { ...this.state.model, accountType: accountTypeDataSource.filter((r) => r.value == this.state.model.accountType)[0].label }, () => {
            this.props.history.push('/profile')
          })
        }
      },
      this.acountType,
      this.title,
      this.firstName,
      this.lastName,
      this.address,
      this.phone,
      this.mobile,
      this.email)
    }

    onCancel = () => {
      this.props.history.goBack()
    }

    onChange = (change: Partial<ProfileModel>) => {
      this.setState({
        model: { ...this.state.model, ...change },
      })
    }

    render() {
      return (
        <div className="container-fluid pt-2">
          <div className="row">
            <div className="col-lg-9">
              <h2>Request to change account type</h2>

              <TextRadioButtonField
                ref={(r) => this.acountType = r}
                id="acountType"
                label="Please select required account type"
                value={this.state.model.accountType}
                onChange={(accountType) => this.onChange({ accountType })}
                dataSource={accountTypeDataSource.filter((r) => r.value != this.state.currentAccountType)}
                block={false}
                required
              />

              <p>Please review and update your contact details below.</p>
              <AbnField
                id="abn"
                label="Australian Business Number (ABN)"
                value={this.state.model.abn}
                required
                block={false}
                onChange={(v) => { }}
                disabled
              />
              <TextField
                id="registredName"
                label="Registered business name as per ABR record"
                value={this.state.model.registredName}
                required
                onChange={(v) => { }}
                disabled
              />
              <SalutationField
                ref={(r) => this.title = r}
                id="title"
                label="Title"
                value={this.state.model.title}
                onChange={(title) => this.onChange({ title })}
                required
              />
              <div className="clearfix">
                <TextField
                  ref={(r) => this.firstName = r}
                  className="float-left mr-3"
                  id="firstName"
                  label="First Name"
                  value={this.state.model.firstName}
                  onChange={(firstName) => this.onChange({ firstName })}
                  required
                  disabled
                />
                <TextField
                  ref={(r) => this.lastName = r}
                  className="float-left"
                  id="lastName"
                  label="Last Name"
                  value={this.state.model.lastName}
                  onChange={(lastName) => this.onChange({ lastName })}
                  required
                  disabled
                />
              </div>
              <AddressField
                ref={(r) => this.address = r}
                id="address"
                label="Address"
                value={this.state.model.address}
                onChange={(address) => this.onChange({ address })}
                required
                countries={this.state.addressCountries}
              />
              <PhoneField
                ref={(r) => this.phone = r}
                id="phone"
                label="Telephone number (e.g. +61 2 9999 9999)"
                value={this.state.model.phone}
                onChange={(phone) => this.onChange({ phone })}
                required
                block={false}
              />
              <PhoneField
                ref={(r) => this.mobile = r}
                id="mobile"
                label="Mobile phone number (e.g. +61 499 999 999)"
                value={this.state.model.mobile}
                onChange={(mobile) => this.onChange({ mobile })}
                block={false}
              />
              <EmailField
                ref={(r) => this.email = r}
                id="email"
                label="Email"
                value={this.state.model.email}
                onChange={(email) => this.onChange({ email })}
                required
              />
              <Alert className="emdg-page-alerts">
                Please Note: Austrade will use email addresses for contact person and consultant for all correspondence and may send commercial-in-confidence information
              </Alert>

              <div className="clearfix mt-3">
                <Button className="emdg-btn float-right" onClick={this.onSave}>Submit</Button>
                <Button className="emdg-btn emdg-btn--secondary float-left" onClick={this.onCancel}>Cancel</Button>
              </div>

              <Backdrop on={this.state.loading} />
              <TimeoutPopup />
            </div>
          </div>
        </div>
      )
    }
}
